module.exports = __webpack_public_path__ + "img/logo_minified.b055f69c.svg";